export default __webpack_public_path__ + "static/media/splt.8c050015.jfif";